var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("veneer-log", {
        attrs: {
          log: _vm.getConcreteItem(_vm.item),
          "watchlist-item": _vm.item,
          virtual: _vm.isItemVirtual(_vm.item),
          "is-public": _vm.isPublic,
          "measurement-list-dialog": true,
          "watchlist-dialog": true
        },
        scopedSlots: _vm._u(
          [
            {
              key: "additionalInfo",
              fn: function() {
                return [
                  _c("q-separator", { attrs: { spaced: "" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "q-py-md" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm.user && !_vm.isPublic
                          ? [
                              _c("div", { staticClass: "col-12" }, [
                                _c("span", { staticClass: "text-h5" }, [
                                  _vm._v(_vm._s(_vm.$t("furtherInformation")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      type: "number",
                                      prefix: _vm.$t("label.price"),
                                      suffix: _vm.priceUnit,
                                      "input-class": "text-right"
                                    },
                                    model: {
                                      value: _vm.newPrice,
                                      callback: function($$v) {
                                        _vm.newPrice = $$v
                                      },
                                      expression: "newPrice"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      placeholder: _vm.$t("addDescription"),
                                      label: _vm.$t("label.comment"),
                                      autogrow: ""
                                    },
                                    model: {
                                      value: _vm.newDescription,
                                      callback: function($$v) {
                                        _vm.newDescription = $$v
                                      },
                                      expression: "newDescription"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : [
                              _vm.item.price
                                ? _c("div", { staticClass: "col-12" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("label.price")) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("currency")(_vm.item.price)
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.item.description
                                ? _c("div", { staticClass: "col-12" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.item.description) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ]
                      ],
                      2
                    )
                  ])
                ]
              },
              proxy: true
            },
            !_vm.isPublic
              ? {
                  key: "additionalActions",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.user
                            ? _c("q-btn", {
                                attrs: {
                                  icon: "delete",
                                  "text-color": "primary",
                                  "no-caps": "",
                                  flat: "",
                                  size: "11px",
                                  label: _vm.$t("button.remove")
                                },
                                on: { click: _vm.removeFromWatchlist }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.user
                            ? _c("q-btn", {
                                attrs: {
                                  icon: "photo",
                                  "text-color": "primary",
                                  "no-caps": "",
                                  flat: "",
                                  size: "11px",
                                  label: _vm.$t(
                                    "tooltip.setWatchlistItemLogImages"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showLogImagesDialog.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }